<form id="settingForm" [formGroup]="settingForm" (ngSubmit)="save(settingForm)" class="setting-container">
  <span style="min-width: 290px; max-width: 290px; margin-top: auto; margin-bottom: auto;">{{setting.name}}: </span>
  <span>
    @if (setting.type == 'number') {
    <input pInputText [name]="'setting' + setting.id" [type]="setting.type" formControlName="value" min="0"
      [step]="setting.step" [pKeyFilter]="setting.step == 1 ? 'pint' : 'num'" [disabled]="isLoading" />
    }
    @if (setting.type == 'text') {
    <textarea rows="10" class="form-control" cols="50" pInputTextarea formControlName="value"
      [name]="'setting' + setting.id" [disabled]="isLoading" fluid></textarea>
    }
  </span>
  <span>
    <p-button type="submit" severity="success" [disabled]="!settingForm.valid || isLoading" label="Save">
    </p-button>
    @if (isLoading) {
    <span style="vertical-align: middle; margin-left: 5px;">
      <p-progressSpinner [style]="{width: '26px', height: '26px'}" strokeWidth="8" fill="#EEEEEE"
        animationDuration="1.5s"></p-progressSpinner>
    </span>
    }
  </span>
  <br />
  @if (value.invalid && (value.dirty || value.touched)) {
  <span>
    @if (value.errors.required) {
    <span>
      <p-message severity="error" [text]="'A value is required'" class="setting-message"></p-message>
    </span>
    }
  </span>
  }
</form>
<hr />